import { render, staticRenderFns } from "./CitationListBatchReview.vue?vue&type=template&id=d87caa1a"
import script from "./CitationListBatchReview.vue?vue&type=script&lang=js"
export * from "./CitationListBatchReview.vue?vue&type=script&lang=js"
import style0 from "./CitationListBatchReview.vue?vue&type=style&index=0&id=d87caa1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports